import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { ICrudGetAction, TextFormat } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { IRootState } from 'app/shared/reducers';
import { getEntity } from './subscription-history.reducer';
import { ISubscriptionHistory } from 'app/shared/model/subscription-history.model';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';

export interface ISubscriptionHistoryDetailProps extends StateProps, DispatchProps, RouteComponentProps<{ id: string }> {}

export const SubscriptionHistoryDetail = (props: ISubscriptionHistoryDetailProps) => {
  useEffect(() => {
    props.getEntity(props.match.params.id);
  }, []);

  const { subscriptionHistoryEntity } = props;
  return (
    <Row>
      <Col md="8">
        <h2>
          SubscriptionHistory [<b>{subscriptionHistoryEntity.id}</b>]
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="startDate">Start Date</span>
          </dt>
          <dd>
            {subscriptionHistoryEntity.startDate ? (
              <TextFormat value={subscriptionHistoryEntity.startDate} type="date" format={APP_LOCAL_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <span id="endDate">End Date</span>
          </dt>
          <dd>
            {subscriptionHistoryEntity.endDate ? (
              <TextFormat value={subscriptionHistoryEntity.endDate} type="date" format={APP_LOCAL_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <span id="transactionId">Transaction Id</span>
          </dt>
          <dd>{subscriptionHistoryEntity.transactionId}</dd>
          <dt>
            <span id="transactionDate">Transaction Date</span>
          </dt>
          <dd>
            {subscriptionHistoryEntity.transactionDate ? (
              <TextFormat value={subscriptionHistoryEntity.transactionDate} type="date" format={APP_LOCAL_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>Subscription Plan</dt>
          <dd>{subscriptionHistoryEntity.subscriptionPlan ? subscriptionHistoryEntity.subscriptionPlan.id : ''}</dd>
          <dt>User</dt>
          <dd>{subscriptionHistoryEntity.user ? subscriptionHistoryEntity.user.login : ''}</dd>
          <dt>Statuses</dt>
          <dd>{subscriptionHistoryEntity.statuses ? subscriptionHistoryEntity.statuses.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/subscription-history" replace color="info">
          <FontAwesomeIcon icon="arrow-left" /> <span className="d-none d-md-inline">Back</span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/subscription-history/${subscriptionHistoryEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" /> <span className="d-none d-md-inline">Edit</span>
        </Button>
      </Col>
    </Row>
  );
};

const mapStateToProps = ({ subscriptionHistory }: IRootState) => ({
  subscriptionHistoryEntity: subscriptionHistory.entity,
});

const mapDispatchToProps = { getEntity };

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(SubscriptionHistoryDetail);
